import React, { ReactNode } from "react";

import "./ModalFormControl.scss";

export const ModalFormControl = ({ children }: { children: ReactNode }) => {
  return <div className="modal-form-control">{children}</div>;
};
